import { ChatResponseSchema, ConversationListResponseSchema, ConversationWithMessagesSchema, ConversationMessagesResponseSchema, ButtonPressResponseSchema, } from '@packages/types';
import { api } from '../client.js';
export function sendChatMessage(messages) {
    return api('/chat', ChatResponseSchema, {
        method: 'POST',
        body: { messages },
    });
}
export function listConversations(accountId, params) {
    const qs = new URLSearchParams();
    if (params?.cursor)
        qs.set('cursor', params.cursor);
    if (params?.limit != null)
        qs.set('limit', String(params.limit));
    const query = qs.toString();
    return api(`/accounts/${accountId}/conversations${query ? `?${query}` : ''}`, ConversationListResponseSchema);
}
export function getConversation(accountId, conversationId) {
    return api(`/accounts/${accountId}/conversations/${conversationId}`, ConversationWithMessagesSchema);
}
export function listConversationMessages(accountId, conversationId, params) {
    const qs = new URLSearchParams();
    if (params?.cursor)
        qs.set('cursor', params.cursor);
    if (params?.limit != null)
        qs.set('limit', String(params.limit));
    const query = qs.toString();
    return api(`/accounts/${accountId}/conversations/${conversationId}/messages${query ? `?${query}` : ''}`, ConversationMessagesResponseSchema);
}
/** Press button `index` under reply `messageId`: runs the call the server pinned to it, as the caller, at most once. */
export function pressButton(accountId, conversationId, messageId, index) {
    return api(`/accounts/${accountId}/conversations/${conversationId}/messages/${messageId}/buttons/${index}/press`, ButtonPressResponseSchema, { method: 'POST', body: {} });
}
